import {} from '../../config/constants';
import { IActorStep1 } from '../types/Step';

/**
 * Проверка данных первого шага регистрации
 * @param step Данные первого шага
 */
export const checkActorStep1 = (step: IActorStep1) => {
  const {
    isActorLicenseAgreementConfirmed,
    isPersonalDataRulesConfirmed,
    isUserIsSixteenConfirmed
  } = step;
  let isValid = true;

  if (
    !isActorLicenseAgreementConfirmed ||
    !isPersonalDataRulesConfirmed ||
    !isUserIsSixteenConfirmed
  )
    isValid = false;

  return {
    isValid
  };
};
